// src/button/src/hooks/use-base-button-props.tsx
import * as React from "react";
var useBaseButtonProps = (props) => {
  return React.useMemo(() => {
    const { as, disabled, busy } = props;
    const nonFocusable = disabled === true || busy === true;
    if (as === "a") {
      const { download, href, id, ref, rel, target, onClick } = props;
      return {
        "aria-disabled": disabled,
        "data-busy": busy,
        download,
        href: nonFocusable ? void 0 : href,
        id,
        onClick: nonFocusable ? void 0 : onClick,
        ref,
        rel,
        role: nonFocusable ? "link" : void 0,
        tabIndex: 0,
        target
      };
    } else if (as === "button" || as === void 0) {
      const { id, name, ref, type, value, onClick } = props;
      return {
        "aria-disabled": disabled,
        "data-busy": busy,
        id,
        name,
        onClick: nonFocusable ? void 0 : onClick,
        ref,
        type,
        value
      };
    }
    return props;
  }, [props]);
};

export {
  useBaseButtonProps
};
